import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static outlets = [ "modal", "images-carousel" ]

   show(event) {
      const imageId = event.params.imageId;
      this.modalOutlets.forEach(modal => {
         modal.show();
      });
      this.imagesCarouselOutlets.forEach(carousel => {
         carousel.gotoImage(imageId);
      });
   }
}
